import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-delete",
  "use": "icon-delete-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" id=\"icon-delete\">\r\n  <polyline points=\"3,6 5,6 21,6\" />\r\n  <path d=\"m19,6v14a2,2 0 0,1 -2,2H7a2,2 0 0,1 -2,-2V6m3,0V4a2,2 0 0,1 2,-2h4a2,2 0 0,1 2,2v2\" />\r\n  <line x1=\"10\" y1=\"11\" x2=\"10\" y2=\"17\" />\r\n  <line x1=\"14\" y1=\"11\" x2=\"14\" y2=\"17\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol